import { render, staticRenderFns } from "./startWorkList.vue?vue&type=template&id=8df0280e&scoped=true"
import script from "./startWorkList.vue?vue&type=script&lang=js"
export * from "./startWorkList.vue?vue&type=script&lang=js"
import style0 from "./startWorkList.vue?vue&type=style&index=0&id=8df0280e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df0280e",
  null
  
)

export default component.exports